import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';

@Component({
  selector: 'app-usuario-empresa-listar',
  templateUrl: './usuario-empresa-listar.component.html',
  styleUrls: ['./usuario-empresa-listar.component.scss']
})
export class UsuarioEmpresaListarComponent implements OnInit {

  constructor(private empresaService: EmpresaService,
    private usuarioService: UsuarioService,) { }


  loading: boolean = false;
  @Output() emissor = new EventEmitter();
  @Input() empresa?: Empresa;
  grupos: Grupo[] = [];
  usuarios: Usuario[] = [];
  

  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
    this.listarUsuarios();
  }

  listarUsuarios() {
    this.usuarioService.listarPorEmpresaId(this.empresa?.id).subscribe({
      next: (data: Usuario[]) => {
        this.usuarios = data;
      },
      error: (err: any) => console.log(err)
    });
  }

  editar(id: number){
    this.emissor.emit({
      modo: 'EDITAR',
      id: id
    })
  }

  detalhar(id: number){
    this.emissor.emit({
      modo: 'DETALHAR',
      id: id
    })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

}
